import { HistoryItem } from 'store/state/selectors/insights/prices';
import { TableColumn } from 'ds/components/table';

export const getHistoryDateColumnConfig = (isMobile: boolean): Partial<TableColumn<HistoryItem>> => ({
  sortFn: (items: HistoryItem[]) => items.sort((a, b) => +new Date(b.date) - +new Date(a.date)),
  width: isMobile ? '40%' : '17%',
  gap: isMobile ? 24 : 16,
});
